import {
  SESSION_STATE_FINALIZED,
  getSessionStateId,
} from "./liveTrainingSessionWindow";
import {
  TE_STATE_CANCELLED,
  TE_STATE_FINALIZED,
  TE_STATE_PAUSED,
  TE_STATE_STARTED,
} from "./coachExerciseNavigation";

/**
 * Session-level closed/finalized: presence stats are locked today in the UI,
 * but coaches must still be able to correct attendance mistakes.
 */
export function isSessionClosedForPresence(session) {
  if (!session) return false;
  if (session.is_completed === true) return true;
  const id = getSessionStateId(session);
  return (
    id === SESSION_STATE_FINALIZED ||
    id === TE_STATE_FINALIZED ||
    id === "finalized"
  );
}

export function isExerciseLiveForPresenceLock(exerciseStateId) {
  return (
    exerciseStateId === TE_STATE_STARTED || exerciseStateId === TE_STATE_PAUSED
  );
}

export function isExerciseEndedForPresence(exerciseStateId) {
  return (
    exerciseStateId === TE_STATE_FINALIZED ||
    exerciseStateId === TE_STATE_CANCELLED ||
    exerciseStateId === "finalized" ||
    exerciseStateId === "cancelled"
  );
}

/**
 * Who may open PlayerPresenceDialog.
 * Coaches can add/remove players on any exercise that is not finalized.
 * After finalize (or session close) they can still open to correct attendance.
 */
export function canOpenSessionPresenceDialog({
  hasPresencePermission = false,
  exerciseStateId = null,
  sessionClosed = false,
  kotAllowsPresence = false,
} = {}) {
  if (!hasPresencePermission) return false;
  if (kotAllowsPresence) return true;
  if (sessionClosed) return true;
  if (isExerciseEndedForPresence(exerciseStateId)) return true;
  // Scheduled, started, or paused — still allow adds for the next block.
  return true;
}

/** Auto-seat / table mutation after a presence mark — not after finalize. */
export function shouldAutoSeatAfterPresenceChange({
  sessionClosed = false,
  exerciseLive = false,
} = {}) {
  return !sessionClosed && !exerciseLive;
}

/**
 * Seating after finalize is locked for pure players; coaches / monitors /
 * moderators / club admins may still edit table configuration.
 * `canManagePastSessions` kept for call-site compatibility.
 */
export function isTableConfigurationLockedAfterFinalize({
  isFinalized = false,
  canManagePastSessions = false,
  canEditFinalizedSeating = false,
} = {}) {
  const allowed = Boolean(canManagePastSessions || canEditFinalizedSeating);
  return Boolean(isFinalized) && !allowed;
}
